/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Grid, TextField } from "@mui/material";
import ModalContent from "components/ModalContent";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import InputFileUpload from "./InputFile";
import toast from "react-hot-toast";

const ModalAgregarEstudio = ({ open, handleClose, onGuardar }) => {
  const [textInfo, setTextInfo] = useState("");
  const [isvalid_textInfo, setisvalid_textInfo] = useState(false);
  const [file, setFile] = useState(null);

  const handleAccept = () => {
    if (!textInfo.trim()) {
      setisvalid_textInfo(true);
      return;
    }
    if (!file) {
        toast.error("Selecionar archivo para continuar");
      return;
    }

    if (onGuardar && typeof onGuardar === "function") {
      onGuardar(textInfo.trim(), file);
    }

    // Limpia estado y cierra
    setTextInfo("");
    setFile(null);
    handleClose();
  };

  return (
    <ModalContent
      title="Agregar estudio"
      maxWidth="md"
      fullWidth
      open={open}
      fullScreen={false}
      handleClose={() => {
        setTextInfo("");
        setFile(null);
        setisvalid_textInfo(false);
        handleClose();
      }}
      handleAcept={handleAccept}
      textAccept="Guardar"
    >
      <MDBox>
        {/* Título del estudio */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography
                variant="h5"
                color="white"
                style={{ opacity: 0.7, fontSize: "0.9rem" }}
              >
                Título Estudio
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              value={textInfo}
              onChange={(e) => setTextInfo(e.target.value)}
              onFocus={() => setisvalid_textInfo(false)}
              label="Ingrese título"
              variant="outlined"
              fullWidth
              size="small"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              error={isvalid_textInfo}
              helperText={
                isvalid_textInfo ? "Es necesario ingresar el texto para continuar" : ""
              }
              sx={{ mb: 3 }}
            />
          </Grid>
        </Grid>

        {/* Archivo */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography
                variant="h5"
                color="white"
                style={{ opacity: 0.7, fontSize: "0.9rem" }}
              >
                Archivo
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <InputFileUpload onchangeFile={setFile} valueF={file} />
          </Grid>
        </Grid>
      </MDBox>
    </ModalContent>
  );
};

export default ModalAgregarEstudio;
